// extracted by mini-css-extract-plugin
export default {"wrapper":"Checkbox_wrapper__Crvj9","input":"Checkbox_input__AW5gY","label":"Checkbox_label__lxji1"};